export const fakeRecommendations = {
  feedbackV1: 'false',
  feedbackV2: 'true',
  feedbackV3: 'false'
};